/**
 * Get nonce for Caddy API requests
 *
 * @returns {string} Nonce value
 */
export function getCaddyNonce() {
	// Try to get nonce from meta tag first
	const nonceMeta = document.querySelector('meta[name="caddy-nonce"]');
	if (nonceMeta) {
		return nonceMeta.getAttribute('content');
	}

	// Fallback to global variable if available
	if (typeof window.caddyData !== 'undefined' && window.caddyData.nonce) {
		return window.caddyData.nonce;
	}

	// Final fallback - get from REST API nonce if available
	const restNonceMeta = document.querySelector('meta[name="wp-rest-nonce"]');
	if (restNonceMeta) {
		return restNonceMeta.getAttribute('content');
	}

	return '';
}

/**
 * Get REST API base URL
 *
 * @returns {string} REST API base URL
 */
export function getCaddyRestUrl() {
	// Try to get REST URL from meta tag first
	const restUrlMeta = document.querySelector('meta[name="caddy-rest-url"]');
	if (restUrlMeta) {
		return restUrlMeta.getAttribute('content');
	}

	// Fallback to constructing URL
	return window.location.origin + '/wp-json/caddy/v1/';
}

/**
 * Get Store API nonce
 *
 * @returns {string|null} Store API nonce value
 */
export function getStoreApiNonce() {
	const storeApiNonceMeta = document.querySelector('meta[name="wc-store-api-nonce"]');
	if (storeApiNonceMeta) {
		return storeApiNonceMeta.getAttribute('content');
	}
	return null;
}

/**
 * Update Store API nonce from response headers.
 * WooCommerce returns a fresh Nonce header in Store API responses.
 *
 * @param {Response} response Fetch response object
 */
export function refreshNonceFromResponse(response) {
	const newNonce = response.headers.get('Nonce') || response.headers.get('X-WC-Store-API-Nonce');
	if (newNonce) {
		const meta = document.querySelector('meta[name="wc-store-api-nonce"]');
		if (meta) {
			meta.setAttribute('content', newNonce);
		}
	}
}

/**
 * Fetch cart data from WooCommerce Store API
 *
 * @returns {Promise<Object>} Cart data from Store API
 */
export async function fetchCart() {
	const storeApiNonce = getStoreApiNonce();
	const response = await fetch('/wp-json/wc/store/v1/cart', {
		credentials: 'same-origin',
		headers: storeApiNonce ? { 'Nonce': storeApiNonce } : {}
	});

	// Refresh nonce from response headers for long-lived tabs
	refreshNonceFromResponse(response);

	if (!response.ok) {
		throw new Error('Failed to fetch cart');
	}

	return response.json();
}
